import { queryKeys } from '@/lib/query-keys';
import { billingClient } from '@/lib/api/ts-rest';
import type { OrgBillingLine, OrgBillingLines } from '@octave/contracts';
import { useQuery } from '@tanstack/react-query';
import { useDefaultSite } from './useDefaultSite';
import { useCurrentOrganization } from './useOrganization';

const STALE_TIME_MS = 5 * 60 * 1000;

/**
 * Latest-period per-line billed breakdown as a Map by lineId — for the
 * « Mes lignes » hors-forfait badge. No period filter → the scope's latest
 * available run (handles the upload lag).
 */
export const useLinesBillingMap = () => {
  const { data: organization } = useCurrentOrganization();
  const { currentSite } = useDefaultSite();
  return useQuery<OrgBillingLines, Error, Map<string, OrgBillingLine>>({
    queryKey: queryKeys.billing.linesMap(currentSite?.id, organization?.id),
    queryFn: async () => {
      const res = await billingClient.getOrgBillingLines({
        params: { organizationId: organization!.id },
        query: currentSite ? { siteId: currentSite.id } : {},
      });
      if (res.status !== 200) throw new Error('Failed to load billing');
      return res.body;
    },
    enabled: !!organization,
    select: (data) => new Map(data.lines.map((l) => [l.mobileLineId, l])),
    refetchOnWindowFocus: false,
    staleTime: STALE_TIME_MS,
  });
};
